import React from 'react';
import { Box, Container, Grid, Typography, Avatar, useTheme,Button } from '@mui/material';
import { Groups, BusinessCenter, School } from '@mui/icons-material';
import team1 from "./images/team1.png"
import team2 from "./images/team2.png"
import team3 from "./images/team3.png"
import Footer from './layout/Footer';
import Navbar from './layout/Navbar';

const TeamMemberPage = () => {
  const theme = useTheme();

  const teamMembers = [
    {
      name: "Niroj Karanjit Sharma",
      role: "CEO",
      bio: "After having 15 yrs. of experience in other direct selling companies, he believes that direct selling industry is a business which is based on creating, cultivating and nurturing Relationships. With an outstanding skill of sales, marketing and operations he continues his mission of bridging the gap between Entrepreneurship and corporate environment. He believes that through right education system and skill based training it is possible to change the face of Entrepreneurship with the contribution to society and the Nation.",
      image: team1 // Replace with actual image path
    },
    {
        name: "Arjun Chauhan",
        role: "Managing Director",
        bio: "Mr. Chauhan, a resilient entrepreneur and leader, began his journey as a barista for a renowned coffee brand. Committed to uplifting people regardless of background, he believes in the power of youth to shape a better nation. His travels across the USA and Europe have deepened his understanding in economic development. His vision is to create a platform empowering citizens to transform their social and economic conditions through entrepreneurship.",
        image: team2 // Replace with actual image path
      },
      {
        name: "Sabina Katwal",
        role: "Finance Director",
        bio: "With 15 years in finance, Mrs. Katwal values transparency for organizational success. She ensures financial discipline, taxation, audits, and compliance while strengthening financial well-being. Known for resilience and integrity, she aims to foster a healthy financial system through her expertise.",
        image: team3 // Replace with actual image path
      },
  ];

  return (
    <>
    <Navbar/>
    <Box sx={{ backgroundColor: theme.palette.background.default }}>
      {/* Hero Section */}
      <Box sx={{ 
         position: 'relative',
         minHeight: '400px',
         display: 'flex',
         alignItems: 'center',
         justifyContent: 'center',
         textAlign: 'center',
         overflow: 'hidden',
        background: `
        linear-gradient(15deg, rgba(18, 18, 18, 0.7) 30%, rgba(255, 255, 255, 0.1) 100%),
        url(/path-to-image.jpg) center/cover
      `,
       
        '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `linear-gradient(45deg, ${'#1E7CB7'}33 0%, ${'#2FA8EF'}22 100%)`,
  }
      }}>
          <Container maxWidth="lg" sx={{
            position: 'relative',
            zIndex: 2,
            color: 'common.white',
            px: { xs: 2, md: 4 },
            py: 6
          }}>
           <Typography variant="h1" sx={{
                fontWeight: 400,
                letterSpacing: '0.03em',
                lineHeight: 1.2,
                mb: 3,
                fontSize: { xs: '2.5rem', md: '4rem' },
                textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
                '&:after': {
                  content: '""',
                  display: 'block',
                  width: '80px',
                  height: '2px',
                  backgroundColor: '#2FA8EF',
                  mx: 'auto',
                  mt: 3
                }
              }}>
            Our Leadership Team
          </Typography>

              <Typography variant="subtitle1" sx={{
                maxWidth: '680px',
                mx: 'auto',
                fontSize: { xs: '1.1rem', md: '1.25rem' },
                fontWeight: 300,
                letterSpacing: '0.03em',
                lineHeight: 1.6,
                color: 'rgba(255, 255, 255, 0.9)',
                fontStyle: 'italic',
                mb: 4
              }}>
            Experienced Professionals Driving Your Success
          </Typography>
        </Container>
      </Box>

      {/* Team Grid */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6} justifyContent="center">
          {teamMembers.map((member, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Box sx={{
                height: '100%',
                p: 4,
                borderRadius: 4,
                backgroundColor: 'white',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
                borderTop: '4px solid #2FA8EF',
                textAlign: 'center'
              }}>
                {/* Image Section */}
                <Box sx={{
                  width: 200,
                  height: 200,
                  borderRadius: '50%',
                  backgroundColor: '#2FA8EF33',
                  margin: '0 auto 2rem',
                  overflow: 'hidden',
                  border: '3px solid #1E7CB7'
                }}>
                  <Avatar
                    src={member.image}
                    alt={member.name}
                    sx={{ 
                      width: '100%', 
                      height: '100%',
                      objectFit: 'cover'
                    }}
                  />
                </Box>

                <Typography variant="h5" sx={{ 
                  color: '#1E7CB7',
                  fontWeight: 600,
                  mb: 1
                }}>
                  {member.name}
                </Typography>

                <Typography variant="subtitle1" sx={{ 
                  color: '#2FA8EF',
                  mb: 3,
                  fontWeight: 500
                }}>
                  {member.role}
                </Typography>

                <Box sx={{ 
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 2,
                  mb: 3
                }}>
                  <BusinessCenter sx={{ color: '#1E7CB7' }} />
                  <School sx={{ color: '#1E7CB7' }} />
                </Box>

                <Typography variant="body1" sx={{ 
                  color: '#555',
                  lineHeight: 1.6,
                  textAlign: 'justify'
                }}>
                  {member.bio}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Add More Team Section */}
        {/* <Box sx={{ textAlign: 'center', mt: 8 }}>
          <Groups sx={{ 
            fontSize: 60, 
            color: '#2FA8EF',
            mb: 2 
          }} />
          <Typography variant="h4" sx={{ 
            color: '#1E7CB7',
            fontWeight: 600,
            mb: 3
          }}>
            Meet the Rest of Our Team
          </Typography>
          <Typography variant="body1" sx={{ 
            maxWidth: 800,
            margin: '0 auto',
            color: '#555',
            mb: 4
          }}>
            We're proud to have a diverse team of experts in nutrition, business development, 
            and customer success working behind the scenes to empower your journey.
          </Typography>
          <Button
            variant="outlined"
            sx={{
              borderColor: '#1E7CB7',
              color: '#1E7CB7',
              '&:hover': {
                backgroundColor: '#1E7CB711',
                borderColor: '#1E7CB7'
              },
              px: 6,
              borderRadius: 2
            }}
          >
            View Full Team
          </Button>
        </Box> */}
      </Container>
    </Box>
    <Footer/>
    </>
  );
};

export default TeamMemberPage;